module.exports = __webpack_public_path__ + "static/media/LowScoreGirl.9616830f.svg";